import { OUTFIT_LISTING_FORM } from '../../../../constants/reducer.constants';

const getLoadData = (payload) => {
  let eventSetData = {};
  let loadData = {};
  const { products, internalCampaignId } = payload;
  eventSetData = { products, internalCampaignId };
  loadData = {
    props: {
      initialProps: {
        pageProps: {
          pageData: {
            ...payload,
          },
        },
      },
    },
  };
  return {
    eventSetData,
    loadData,
  };
};

export const getTotalQuantityOfProducts = (completeFormValues, selectedOutfitProducts) => {
  if (selectedOutfitProducts.length === 0) return 0;
  const selectedProductInForm = [];
  selectedOutfitProducts.forEach(({ outfitProduct: { generalProductId } }) => {
    const formName = `${OUTFIT_LISTING_FORM}-${generalProductId}`;
    selectedProductInForm.push(completeFormValues[formName]);
  });

  return selectedProductInForm.reduce(
    (accumulator, item) => accumulator + item?.values?.Quantity,
    0
  );
};

export const getItemIndicatorTitle = (itemIndicatorString, counter, length) => {
  let indicatorTitle = itemIndicatorString?.replace('<counter>', counter);
  indicatorTitle = indicatorTitle?.replace('<length>', length);
  return indicatorTitle;
};

const getOOSFlag = (productInfo) => {
  const { colorFitsSizesMap, tcpMultiPackReferenceUSStore, multiPackUSStore } = productInfo;
  const filteredColorFitsList = colorFitsSizesMap?.filter((item) => item.maxAvailable === 0);
  return (
    colorFitsSizesMap?.length === filteredColorFitsList?.length &&
    !(tcpMultiPackReferenceUSStore && multiPackUSStore)
  );
};

export const showOOSproduct = (productInfo, isKeepAliveEnabled) => {
  if (getOOSFlag(productInfo)) {
    let currentColorEntry = productInfo?.colorFitsSizesMap?.[0];
    if (productInfo?.colorFitsSizesMap?.length > 1) {
      currentColorEntry = productInfo?.colorFitsSizesMap?.find(
        (item) => item.colorProductId === productInfo?.productId
      );
    }
    if (isKeepAliveEnabled && currentColorEntry?.miscInfo?.keepAlive) {
      return true;
    }
    return false;
  }
  return true;
};

export default getLoadData;
